import * as jsonDiff from "jsondiffpatch";
import { Middleware } from "redux";

import { Merchant } from "client/lib/apt-merchant";
import { getSessionId } from "client/utils/session";

import { RootState } from "./initStore";

const sessionId = getSessionId();

const getDiffInState = (previousState: any, nextState: any) => {
  const delta = jsonDiff.diff(previousState, nextState);
  if (delta) {
    return {
      delta,
      previousState,
    };
  }
};

let logErrorCount = 0;

export const persistMiddleware: Middleware<
  any, // Most middleware do not modify the dispatch return value
  RootState
> = (store) => (next) => (action) => {
  const previous = store.getState();
  next(action);
  const ff = Merchant.flagsInstance;
  if (ff?.merchantPortalOperationalEnableReduxDebug) {
    const nextState = store.getState();
    const diff = getDiffInState(previous, nextState);
    const email = store.getState().userState.email;
    if (diff && email) {
      const route = window.location.pathname;
      const prospectId =
        store.getState().merchant.merchantAccount.mlsProspectRef ?? null;
      const { type } = action;
      const logData = {
        timestamp: Date.now(),
        route,
        type,
        prospectId,
        diff,
      };
      const headers = {
        "Content-Type": "application/json",
        "X-Correlation-Id": "testing",
        "X-Session-Id": sessionId,
        "X-App-Version": "redesign",
      };
      if (logErrorCount <= 10) {
        fetch(`/api/redux-log/${email}`, {
          method: "POST",
          body: JSON.stringify(logData),
          headers,
        })
          .then((res) => {
            if (!res.ok) {
              logErrorCount++;
            }
          })
          .catch((_err) => {
            logErrorCount++;
          });
      }
    }
  }
};
